module.exports = __webpack_public_path__ + "img/martin.e01306f7.jpeg";